import React from 'react';

import content from '../../lib/i18n';
import { Text } from 'pp-react';
import styles from './benefits.less';
const i18n = content('hub/components/benefits');

const ListStyle = {
  display: 'flex',
  alignItems: 'center',
  minHeight: '80px',
};

const IconStyle = {
  width: '64px',
  height: '64px',
};

const ListTextStyle = {
  paddingLeft: '20px',
};

const Benefits = () => {
  return (
    <div>
      <Text as='h1' size='xl2' className={styles['npo-charityTitle']}>{i18n('label.all-to-charity')}</Text>
      <div>
        <div style={ListStyle}>
          <img
            src={'https://www.paypalobjects.com/images/Cause/ic_trust@2x.png'}
            style={IconStyle}
          />
          <div style={ListTextStyle}>
            <Text size='md' regular>{i18n('label.trusted-nonprofit')}</Text>
            <Text as='p' size='md'>{i18n('label.vet-confirm-status')}</Text>
          </div>
        </div>
        <div style={ListStyle}>
          <img
            src={'https://www.paypalobjects.com/images/Cause/ic_fees@2x.png'}
            style={IconStyle}
          />
          <div style={ListTextStyle}>
            <Text size='md' regular>{i18n('label.we-pay-fee')}</Text>
            <Text as='p' size='md'>{i18n('label.pp-pays-100%')}</Text>
          </div>
        </div>
        <div style={ListStyle}>
          <img
            src={'https://www.paypalobjects.com/images/Cause/ic_receipt@2x.png'}
            style={IconStyle}
          />
          <div style={ListTextStyle}>
            <Text size='md' regular>{i18n('label.rcv-tax-rept')}</Text>
            <Text as='p' size='md' dangerouslySetInnerHTML={{
              __html: i18n('label.send-tax-receipt'),
            }}/>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Benefits;
